import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetCommission from '@/modules/promotion/api/hooks/useQueryGetCommission'
import CommissionListing from '@/modules/promotion/components/Commission/components/CommissionListing'

function CommissionPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		name: searchQuery,
	}

	const { data, isLoading } = useQueryGetCommission(payload)

	return (
		<PageContainer>
			<CommissionListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedCommisisonPage = withUserPermission(CommissionPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_COMMISSION_CASHBACK],
})

export default GuardedCommisisonPage
